import { useCallback, useMemo } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export function useReCaptchaButton(action = "submit") {
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Create an event handler so you can call the verification on button click event
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    try {
      return await executeRecaptcha(action);
    } catch (e) {
      console.log("Something went wrong during captcha check", e);
    }
  }, [executeRecaptcha, action]);

  const isDisabled =
    // Disable until captcha is responding
    !executeRecaptcha ||
    // Disable if no Site Key was provided
    !process.env.GATSBY_RECAPTCHA_SITE_KEY;

  return useMemo(
    () => ({
      isDisabled,
      handleReCaptchaVerify,
    }),
    [isDisabled, handleReCaptchaVerify]
  );
}
